import { SearchService } from './../../../core/services/search.service';
import { AddConnections } from './../../../core/interface/auth.model';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ProfileService } from 'src/app/core/services/profile.service';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConnectionCancelModalComponent } from 'src/app/components/profile/connection-cancel-modal/connection-cancel-modal.component';
import { environment } from 'src/environments/environment';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';
import { ConnectionRequestSentComponent } from 'src/app/components/all-modals/connection-request-sent/connection-request-sent.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-suggested-connection',
  templateUrl: './suggested-connection.component.html',
  styleUrls: ['./suggested-connection.component.scss'],
  providers: [NgbDropdownConfig]
})
export class SuggestedConnectionComponent implements OnInit, OnDestroy {

  music = [];
  video = [];
  publication = [];
  suggestedConnections: any;
  slider: any;
  imagePath: string;
  connectionSubscription: Subscription;

  @ViewChild('owlCarousel', { static: false }) owlCarousel: any;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 500,
    autoWidth: true,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      },
      1199: {
        items: 5
      }
    },
    nav: true,
  }
  constructor(
    private _profileService: ProfileService,
    private _searchService: SearchService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private _router: Router,
    config: NgbDropdownConfig,
  ) {

    config.placement = 'bottom-right';
  }

  ngOnInit() {
    this.imagePath = environment.url;
    if (this.connectionSubscription) {
      this.connectionSubscription.unsubscribe();
    }
    this.connectionSubscription = this._profileService.fetchSuggestedConnections().subscribe(
      (response: any) => {
        if (response.success) {
          this.suggestedConnections = response.data.connections;
          if (this.suggestedConnections.length > 0 && this.suggestedConnections.length < 5) {
            this.customOptions.responsive['1199'].items = this.suggestedConnections.length;
            this.customOptions.loop = false;
          } else if (this.suggestedConnections.length >= 5) {
            this.customOptions.loop = true;
            this.customOptions.responsive['1199'].items = 5;
          }
        }
      });
  }

  loadProfile(userId) {
    this._router.navigate(['/other-profile', userId])
  }

  addConnection(user) {

    const params: AddConnections = {
      'recipient_id': user.id
    }
    this.spinner.show();
    this._searchService.addConnection(params).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          if (response.message) {
            // COMMENTED BECAUSE WE DON'T NEED CONNECTION MODAL FOR NOW
            // const modalRef = this.modalService.open(ConnectionRequestSentComponent, { centered: true });
            // modalRef.componentInstance.message = response.message;
          } else {
            // COMMENTED BECAUSE WE DON'T NEED CONNECTION MODAL FOR NOW
            // const modalRef = this.modalService.open(ConnectionRequestSentComponent, { centered: true });
            // modalRef.componentInstance.name = (user.business_profile && user.business_profile[0].name) ? user.business_profile[0].name : user.name;
          }


          this.suggestedConnections.forEach(element => {
            if (element.id == user.id) {
              element.connection_status = 'sent';
              if (response.data.connection.parent_approval == 'pending') {
                element['supp_connection_details'] = [];
                element['supp_connection_details']['supplementary_connection_id'] = response.data.connection.id;
              } else {
                element.connection_id = response.data.connection.id;
              }
            }
          });
        }
        else if (response.code == 401) {
          this.spinner.hide();
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.LOGIN_OR_SIGNUP;
        }
        else if (!response.success) {
          this.spinner.hide();
        }
      }, (error: any) => {
        this.spinner.hide();
      });
  }

  cancelRequest(user) {
    const modalRef = this.modalService.open(ConnectionCancelModalComponent, { centered: true });
    modalRef.componentInstance.connection = user;
    modalRef.result.then((result) => {
      if (result === 'success') {
        this.suggestedConnections.forEach(element => {
          if (element.id == user.id) {
            element.connection_status = '';
            element.connection_id = 0;
          }
        });
      }
    }, (reason) => {
      this.spinner.hide();
    });
  }

  ngOnDestroy() {
    if(this.connectionSubscription){

      this.connectionSubscription.unsubscribe();
    }
  }
}
